// extracted by mini-css-extract-plugin
export default {"cls1":"W8Cw37M_OsC4tQeSgbXn","cls2":"MTYSFCekJV8L679syYNq W8Cw37M_OsC4tQeSgbXn","isPhone":"A8xSrPBJkiTH1fLbht3P"};